/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.13.0
 */

import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { icons } from '../../../../../assets';
import { EOnboardingComponentsId } from '../../../../../modules/onboarding/types/onboardingTypes';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { expensesAnalyzerRedirectDailyExpenses } from '../../../../../pages/PageExpensesAnalyzer/pageExpensesAnalyzerActions';
import { TTableButtonsGetTranslation } from '../useTableFooterButtons';

const useTableFooterButtonShowDailyExpenses = (
    getTranslation: TTableButtonsGetTranslation,
) => {
    const dispatch = useDispatch();

    return {
        className: 'table-footer__button btn__show-daily-expenses',
        dataName: 'showDailyExpenses',
        icon: icons.calendarDateIcon,
        id: AccessComponentKeyEnum.FooterButtonShowDailyExpenses,
        onboarding: EOnboardingComponentsId.expensesAnalyzerAccountTableFooterButtonShowDailyExpenses,
        ...getTranslation(AccessComponentKeyEnum.FooterButtonShowDailyExpenses),

        onClick: useCallback(() => {
            dispatch(expensesAnalyzerRedirectDailyExpenses());
        }, [dispatch]),
    };
};

export default useTableFooterButtonShowDailyExpenses;
